// extracted by mini-css-extract-plugin
export default {"performance":"performance_performance__OKnat","infiniteScrollDiv":"performance_infiniteScrollDiv__CWllo"};